var example = {
    "@context": "https://schema.org",
    "@type": "SingleFamilyResidence",
    "url": "http://localhost/bairdteam/?post_type=property&p=2197&preview=true",
    "name": "44 Glenabbey Drive Courtice",
    "numberOfRooms": 8,
    "floorSize": "2000 FTK",
    "accommodationCategory": "RESI",
    "petsAllowed": true,
    "numberOfBedrooms": 3,
    "numberOfBathroomsTotal": 3,
    "numberOfFullBathrooms": 3,
    "numberOfPartialBathrooms": 3,
    "yearBuilt": 1990,
    "address": "44 Glenabbey Drive Courtice",
    "latitude": "43.8947403",
    "longitude": "-78.8033713",
    "description": "Tastefully updated and move in ready",
    "photo": [
        {
            "@type": "ImageObject",
            "url": "https://somedomain.com/veniceb1.jpg",
            "name": "Venice Beach by Day"
        },
        {
            "@type": "ImageObject",
            "url": "https://somedomain.com/veniceb2.jpg",
            "name": "Venice Beach by Night"
        }],
    "additionalProperty": [
        {
            "@type": "PropertyValue",
            "name": "Shed",
            "value": "included"
        },
        {
            "@type": "PropertyValue",
            "name": "pool",
            "value": "included"
        }
    ]
}